import BrowserEnvironment from './browser.environment';

export class ICSAppEnvironment extends BrowserEnvironment {
  constructor () {
    super({});
    this.showCustomerShareCallbacks = [];
  }
  getEnvInfo () {
    return Promise.resolve({ env: 'icsApp' });
  }
  subscribe ({ init, shareSuccess, showCustomerShare }) {
    super.subscribe({ init, shareSuccess });
    this.showCustomerShareCallbacks.push(showCustomerShare);
  }
  showShare () {
    this.execute(this.showCustomerShareCallbacks);
  }
  doShare (shareplatform = 1) {
    const shareData = this.getShareData();
    const icsAppShareParams = {
      shareplatform: shareplatform,
      shareInfo: {
        title: shareData.title,
        url: shareData.link,
        imageUrl: shareData.icon,
        descr: shareData.desc,
        shareType: 2
      }
    };
    window.ICSJavascriptBridge.invoke('uniShareClick', JSON.stringify(icsAppShareParams));
  }
}